import React from 'react';
import ReactDOM from 'react-dom';

import store from './store/index';
import Root from './components/root';
import DesktopApp from './desktop/components/app';

import ensureIntl from './lib/ensure-intl';

import { unregister } from './register-service-worker';

const root = (
  <Root store={store}>
    <DesktopApp />
  </Root>
);

ensureIntl(() => {
  ReactDOM.render(
    root,
    document.getElementById('app-container'),
  );

  unregister();
});



// WEBPACK FOOTER //
// ./src/index.js